'use strict';

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.find/~/es-abstract/helpers/sign.js
// module id = 2705
// module chunks = 0